import { View } from '@antv/g2';

/** tofront: åæ­¥ææåç´ çä½ç½®  */
export function placeElementsOrdered(view: View) {
  if (!view) {
    return;
  }
  const elements = view.geometries[0].elements;
  elements.forEach((elem) => {
    elem.shape.toFront();
  });
}
